import mixins from 'vue-typed-mixins';

export const autofillObserver = mixins().extend({
	data() {
		return {
			isAutofilled: false,
			// you can override these values where it's needed
			autofilledFields: ['email', 'password']
		};
	},
	methods: {
		onAutofilled(e: string) {
			(this as any)[`${e}Autofilled`] = true;
			this.isAutofilled = this.autofilledFields.every((name: string) => (this as any)[`${name}Autofilled`]);
		}
	}
});
